'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isEmpty = {};

exports.__exports = isEmpty;
